import type { AxiosResponse } from 'axios'

import { SEARCH_MACHINE_SORT_ORDERS } from '@/libs/constants'
import { FAPI_MACHINE_ENDPOINT } from '@/libs/constants/b2bApiEndpoints'
import environment from '@/environments/environment.dev'

import HttpClient from './apiHttpClient'

const apiClient = new HttpClient(environment.shopFAPIUrl)

export interface GetMyMachinesPayload {
  pageNumber: number
  pageSize: number
  sortOrder: string
  searchText?: string
}

export interface SearchMachinesPayload {
  searchText: string
  pageSize: number
  pageNumber?: number
  sortOrder?: string
}

export interface Machine {
  orderDate: string
  customerId: string
  countryId: string
  salesOrderNumber: string
  materialNumber: string
  name: string
  imgUrl: string
  referenceNumber: string
  orderType: string
  categoryName: string
  serialNumber: string
  [key: string]: unknown
}

export interface MyMachinesApiResponse {
  currentPage: number
  hasNext: boolean
  hasPrevious: boolean
  items: Machine[]
  pageSize: number
  totalCount: number
  totalPages: number
}

export const machineService = {
  async getMachinesList({
    pageNumber,
    pageSize,
    sortOrder,
  }: GetMyMachinesPayload): Promise<AxiosResponse<MyMachinesApiResponse>> {
    const url = `${FAPI_MACHINE_ENDPOINT}/getall`

    return apiClient.get(url, {
      params: {
        pageNumber,
        pageSize,
        sortOrder,
      },
    })
  },

  async searchMachinesList({
    searchText,
    pageSize,
    pageNumber = 10,
    sortOrder = SEARCH_MACHINE_SORT_ORDERS.ByCategory,
  }: SearchMachinesPayload): Promise<AxiosResponse<MyMachinesApiResponse>> {
    const url = `${FAPI_MACHINE_ENDPOINT}/searchmachine`

    return apiClient.get(url, {
      params: {
        query: searchText,
        pageSize,
        pageNumber,
        sortOrder,
      },
    })
  },
}
